import { createSlice } from "@reduxjs/toolkit";
import { loginReducer } from "../extraReducers/loginReducer";

// 定义初始化数据
const initialState = {
  loginDetail: {} as any,
  changePassword: {} as any,
  getAllAuthoritiesConfig: {} as any,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: loginReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default loginSlice.reducer;
